import { useState, useMemo } from "react";
import { TaskStatus } from "@common/types/task";
import {
    OneClickDoneIcon,
    OneClickTodoIcon,
    OneClickTodoHoverIcon,
    OneClickDoneHoverIcon,
} from "@icons/taskStatuses";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import styles from "./OneClickStatus.module.scss";

interface OneClickStatusProps {
    value: TaskStatus;
    onChange: (value: TaskStatus) => void;
    disabled?: boolean;
}

export const OneClickStatus = ({
    value,
    onChange,
    disabled,
}: OneClickStatusProps) => {
    const [isHovered, setIsHovered] = useState(false);

    const iconToDisplay = useMemo(() => {
        if (isHovered) {
            return value === TaskStatus.DONE ? (
                <OneClickDoneHoverIcon />
            ) : (
                <OneClickTodoHoverIcon />
            );
        }
        if (value === TaskStatus.DONE) {
            return <OneClickDoneIcon />;
        }
        return <OneClickTodoIcon />;
    }, [value, isHovered]);

    const label = value === TaskStatus.DONE ? "Mark To do" : "Mark Done";

    return (
        <Tooltip content={label} disabled={disabled}>
            <button
                className={styles.oneClickStatusButton}
                aria-label={label}
                onClick={() => {
                    onChange(
                        value === TaskStatus.DONE
                            ? TaskStatus.TODO
                            : TaskStatus.DONE,
                    );
                }}
                disabled={disabled}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {iconToDisplay}
            </button>
        </Tooltip>
    );
};
